export default "__VITE_ASSET__3BmO3CmE__"